import { useSelector } from 'react-redux';
import { SeoCrossLinks } from '../../components/SeoCrossLinks';
import { selectSeoCrossLinks } from '../../selectors/landing';

export function SeoCrossLinksContainer() {
  const seoBlocks = useSelector(selectSeoCrossLinks);

  if (seoBlocks.length === 0) {
    return null;
  }

  return <SeoCrossLinks seoBlocks={seoBlocks} />;
}
